define('adminGenericEmailDomainsListView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'tableView',
  'adminGenericEmailDomainsListHeaderToolsView',
  'adminGenericEmailDomainsListRowToolsView',
  'entities/admin/generic_email_domains'
], function (
  Module,
  App,
  _,
  $,
  TableView,
  HeaderToolsView,
  RowToolsView
) {
  'use strict';

  // Admin screen to manage the global generic / free email domains (gmail.com, ...)
  // that are excluded from company email-domain grouping. Reuses the shared paginated table.
  Module.exports = TableView.extend({
    className: 'admin-generic-email-domains-list-view ' + TableView.prototype.className,
    pageMode: 'pagination',

    setFields: function () {
      return [{
        name: 'Domain',
        label: _.i18n('admin.genericEmailDomains.domain', null, 'Domain'),
        className: 'domain',
        bind: 'domain',
        modelEvent: 'change:domain'
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: RowToolsView,
        headerView: HeaderToolsView
      }];
    },

    fetch: function (first, pageSize) {
      var defer = $.Deferred();
      if (this.fetchRequest) { this.fetchRequest.abort(); }
      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('genericEmailDomains:get-url', { first: first, pageSize: pageSize }),
        success: function (items) {
          var models = _.map(items || [], function (item) {
            return App.request('genericEmailDomains:model', item);
          });
          defer.resolve(models);
        }
      });
      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();
      if (this.fetchCountRequest) { this.fetchCountRequest.abort(); }
      this.fetchCountRequest = $.ajax({
        url: App.request('genericEmailDomains:row-count-url'),
        success: function (resp) { defer.resolve(resp); }
      });
      return defer.promise();
    }
  });
});

